var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"title":_vm.title,"width":_vm.width,"placement":_vm.placement,"trigger":_vm.trigger,"content":_vm.content}},[_vm._t("default"),_vm._v(" "),_c('i',{staticClass:"el-icon-question",staticStyle:{"color":"#909399"},attrs:{"slot":"reference"},slot:"reference"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a0b2e80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tip.vue
// module id = null
// module chunks = 